module.exports = __webpack_public_path__ + "static/media/globalshala_logo.9bb048cf.png";